import { render, staticRenderFns } from "./UpgradeDialog.vue?vue&type=template&id=3921709a&scoped=true"
import script from "./UpgradeDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeDialog.vue?vue&type=script&lang=js"
import style0 from "./UpgradeDialog.vue?vue&type=style&index=0&id=3921709a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921709a",
  null
  
)

export default component.exports